import { useEffect,useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useAppTheme } from "../../../context/ThemeContext";

const emptyForm={
  nombres:"",
  apellidos:"",
  identificacion:"",
  correo:"",
  telefono:"",
  is_active:true,
};

export default function AdministratorModal({
  open,
  onClose,
  onSave,
  administrator,
  saving,
}){
  const {colors,typography}=useAppTheme();
  const [form,setForm]=useState(emptyForm);
  const [errors,setErrors]=useState({});

  useEffect(()=>{
    if(!open) return;

    if(administrator){
      setForm({
        nombres:administrator.nombres||"",
        apellidos:administrator.apellidos||"",
        identificacion:administrator.identificacion||"",
        correo:administrator.correo||"",
        telefono:administrator.telefono||"",
        is_active:administrator.is_active!==false,
      });
    }else{
      setForm(emptyForm);
    }

    setErrors({});
  },[open,administrator]);

  const handleChange=(field,value)=>{
    setForm((current)=>({
      ...current,
      [field]:value,
    }));

    setErrors((current)=>({
      ...current,
      [field]:"",
    }));
  };

  const handleSubmit=()=>{
    const nextErrors={};

    if(!form.nombres.trim()) nextErrors.nombres="Ingresa los nombres";
    if(!form.apellidos.trim()) nextErrors.apellidos="Ingresa los apellidos";
    if(!form.identificacion.trim()) nextErrors.identificacion="Ingresa la identificación";
    if(!form.correo.trim()) nextErrors.correo="Ingresa el correo";
    if(!form.telefono.trim()) nextErrors.telefono="Ingresa el teléfono";

    if(form.correo.trim()&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.correo.trim())){
      nextErrors.correo="Ingresa un correo válido";
    }

    if(Object.keys(nextErrors).length){
      setErrors(nextErrors);
      return;
    }

    onSave({
      nombres:form.nombres.trim(),
      apellidos:form.apellidos.trim(),
      identificacion:form.identificacion.trim(),
      correo:form.correo.trim().toLowerCase(),
      telefono:form.telefono.trim(),
      is_active:form.is_active,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={saving?undefined:onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx:{
          borderRadius:"14px",
          boxShadow:"none",
          border:`1px solid ${colors.border}`,
          backgroundColor:colors.surface,
          m:{xs:1.5,sm:3},
          width:{xs:"calc(100% - 24px)",sm:"100%"},
        },
      }}
    >
      <DialogTitle
        sx={{
          px:{xs:2,sm:2.5},
          pt:2.3,
          pb:1,
        }}
      >
        <Typography
          sx={{
            fontSize:typography.sizes.xl,
            fontWeight:typography.weights.extraBold,
            color:colors.text,
          }}
        >
          {administrator?"Editar administrador":"Nuevo administrador"}
        </Typography>

        <Typography
          sx={{
            mt:0.4,
            fontSize:typography.sizes.sm,
            color:colors.textSecondary,
          }}
        >
          Registra los datos del responsable de la administración de la liga.
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          px:{xs:2,sm:2.5},
          pt:"14px !important",
        }}
      >
        <Box
          sx={{
            display:"grid",
            gridTemplateColumns:{xs:"1fr",sm:"1fr 1fr"},
            gap:1.5,
          }}
        >
          <TextField
            label="Nombres"
            value={form.nombres}
            onChange={(event)=>handleChange("nombres",event.target.value)}
            error={Boolean(errors.nombres)}
            helperText={errors.nombres}
            fullWidth
          />

          <TextField
            label="Apellidos"
            value={form.apellidos}
            onChange={(event)=>handleChange("apellidos",event.target.value)}
            error={Boolean(errors.apellidos)}
            helperText={errors.apellidos}
            fullWidth
          />

          <TextField
            label="Identificación"
            value={form.identificacion}
            onChange={(event)=>handleChange("identificacion",event.target.value)}
            error={Boolean(errors.identificacion)}
            helperText={errors.identificacion}
            fullWidth
          />

          <TextField
            label="Teléfono"
            value={form.telefono}
            onChange={(event)=>handleChange("telefono",event.target.value)}
            error={Boolean(errors.telefono)}
            helperText={errors.telefono}
            fullWidth
          />

          <TextField
            label="Correo"
            type="email"
            value={form.correo}
            onChange={(event)=>handleChange("correo",event.target.value)}
            error={Boolean(errors.correo)}
            helperText={errors.correo}
            fullWidth
            sx={{
              gridColumn:{xs:"auto",sm:"1 / -1"},
            }}
          />

          {administrator&&(
            <FormControlLabel
              sx={{
                gridColumn:{xs:"auto",sm:"1 / -1"},
                m:0,
                color:colors.text,
              }}
              control={
                <Switch
                  size="small"
                  color="secondary"
                  checked={form.is_active}
                  onChange={(event)=>handleChange("is_active",event.target.checked)}
                />
              }
              label={form.is_active?"Administrador activo":"Administrador inactivo"}
            />
          )}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px:{xs:2,sm:2.5},
          py:2,
          borderTop:`1px solid ${colors.border}`,
          gap:1,
        }}
      >
        <Button
          onClick={onClose}
          disabled={saving}
          sx={{
            color:colors.textSecondary,
          }}
        >
          Cancelar
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSubmit}
          disabled={saving}
        >
          {saving
            ?"Guardando..."
            :administrator
              ?"Guardar cambios"
              :"Crear administrador"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}